export default __webpack_public_path__ + "media/calendar-w.587a1cd2.svg";